import React, { Component } from 'react'

export default class Footer extends Component {
  render() {
    return (
        <footer>
        <p>MuchToDo, a web app from <a href="http://www.chriscarlson.org/">Chris Carlson</a>.</p>
        </footer>
    )  
}
}
